"use client"

import React from "react"
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaHome, FaBookOpen, FaInfoCircle, FaNewspaper, FaFacebook, FaWhatsapp, FaInstagram, FaGlobe } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import "../styles/design-system.css";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer-container-fluid">
      {/* Decorative Top Curve */}
      <div className="footer-top-curve">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"></path>
        </svg>
      </div>

      <div className="footer-content">
        <div className="footer-grid">

          {/* Column 1: Brand */}
          <div className="footer-brand">
            <h2>SUN LANKA</h2>
            <span className="tagline">Vocational Training Centre</span>
            <p>Bridging cultures and building careers. Your gateway to professional excellence in Japan and beyond.</p>

            <div className="social-icons-row">
              {[
                { icon: FaWhatsapp, link: "https://wa.me/94729253277", color: '#25D366' },
                { icon: FaFacebook, link: "https://facebook.com/100090698896706", color: '#1877F2' },
                { icon: FaInstagram, link: "https://instagram.com", color: '#E4405F' },
                { icon: FaGlobe, link: "https://sunlanka.com", color: '#FFCB05' }
              ].map((social, i) => (
                <a
                  key={i}
                  href={social.link}
                  className="social-icon"
                  style={{ '--hover-color': social.color }}
                  onMouseEnter={(e) => e.currentTarget.style.background = social.color}
                  onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.05)'}
                  target="_blank"
                  rel="noreferrer"
                >
                  <social.icon />
                </a>
              ))}
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="footer-links">
            <h3 className="footer-heading">Explore</h3>
            <ul>
              {[
                { icon: FaHome, label: "Home", to: "home" },
                { icon: FaBookOpen, label: "Academic", to: "academic" },
                { icon: FaInfoCircle, label: "About Us", to: "about" },
                { icon: FaNewspaper, label: "News & Events", to: "newsfeed" },
              ].map((link, i) => (
                <li key={i}>
                  <ScrollLink
                    to={link.to}
                    smooth={true}
                    duration={800}
                    offset={-50}
                    className="footer-link"
                    style={{ cursor: 'pointer' }}
                  >
                    <link.icon style={{ fontSize: '0.9rem' }} /> {link.label}
                  </ScrollLink>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Contact */}
          <div className="footer-contact">
            <h3 className="footer-heading" style={{ borderBottomColor: 'var(--color-primary-yellow)' }}>Contact</h3>
            <ul>
              <li className="contact-row">
                <div className="contact-icon-box" style={{ color: 'var(--color-primary-red)', background: 'rgba(217, 0, 52, 0.1)' }}>
                  <FaPhone />
                </div>
                <div className="contact-text">
                  <div>Call Us</div>
                  <a href="tel:+94114382900">+94 114 382 900</a>
                </div>
              </li>
              <li className="contact-row">
                <div className="contact-icon-box">
                  <FaEnvelope />
                </div>
                <div className="contact-text">
                  <div>Email Us</div>
                  <a href="mailto:sunlaankaar@gmail.com">sunlaankaar@gmail.com</a>
                </div>
              </li>
              <li className="contact-row">
                <div className="contact-icon-box" style={{ color: '#fff' }}>
                  <FaMapMarkerAlt />
                </div>
                <div className="contact-text">
                  <div>Visit Us</div>
                  <div>543, Athurugiriya Road,<br />Malabe, Sri Lanka</div>
                </div>
              </li>
            </ul>
          </div>

          {/* Column 4: Map */}
          <div>
            <h3 className="footer-heading" style={{ borderBottom: 'none' }}>Location</h3>
            <div className="footer-map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15843.89667827825!2d79.9575122!3d6.9146775!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae257321e1495b5%3A0xe677f54c25141029!2sMalabe%2C%20Sri%20Lanka!5e0!3m2!1sen!2suk!4v1700000000000!5m2!1sen!2suk"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Sun Lanka Location"
              ></iframe>
            </div>
          </div>

        </div>

        <div className="footer-bottom">
          <p>© 2025 Sun Lanka Vocational Training Centre.</p>
          <div className="footer-bottom-links">
            <Link to="/">Privacy Policy</Link>
            <Link to="/">Terms of Service</Link>
            <Link to="/admin-login">Admin Login</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
